import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Dashboard from "./Dashboard";
import Accounts from "./Accounts";

export default function PhoneBridge() {
  const tabs = [
    { id: "dashboard", label: "Dashboard", content: <Dashboard /> },
    { id: "accounts", label: "Accounts", content: <Accounts /> },
  ];
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <div
      className="text-dark min-vh-100"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      <main className=" bg-white p-4">
        {/* Dynamic Tabs */}
        <nav className="mb-4">
          <ul className="nav nav-tabs border-0">
            {tabs.map((tab) => (
              <li key={tab.id} className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab.id === tab.id
                      ? "active text-dark border-bottom border-3"
                      : "text-muted"
                  } border-0 fw-semibold`}
                  onClick={() => setActiveTab(tab)}
                  aria-current={activeTab.id === tab.id ? "page" : undefined}
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        {/* Dynamic Content */}
        <div className="tab-content">{activeTab.content}</div>
      </main>
    </div>
  );
}
